




























import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { RegionState, Region, DataRegion } from '@/store/region/types';
import {
  AdminSiteState,
  AdminSite,
  DataAdminSite,
} from '@/store/adminsite/types';
import { UserState, User, DataUser } from '@/store/user/types';
import { IMessage } from '@/store/alert/types';
import Alert from '@/components/Alert.vue';
import Table from '@/components/Table.vue';
import Cards from '@/components/Cards.vue';

@Component({
  components: {
    Alert,
    Table,
    Cards,
  },
})
export default class ManagementUser extends Vue {
  @Mutation('alert/SHOW') private alert: (alertMessage: IMessage) => void;
  @Mutation('USER_PUT', { namespace: 'user' })
  private userPut: any;
  @Mutation('USER_REGION_CREATE', { namespace: 'user' })
  private userCreate: any;
  @Mutation('USER_REGION_DELETE', { namespace: 'user' })
  private userDelete: any;
  @Action('add', { namespace: 'user' }) private add: (
    user: User,
  ) => Promise<undefined>;
  @Action('put', { namespace: 'user' }) private put: (
    user: User,
  ) => Promise<undefined>;
  @Action('delete', { namespace: 'user' }) private delete: (
    _id: string,
  ) => Promise<undefined>;

  @Action('get', { namespace: 'user' }) private get: () => void;
  @Action('get', { namespace: 'region' }) private getRegion: () => void;

  @State('user') private userState?: UserState;
  @State('region') private regionState?: RegionState;

  @Prop(String) private search?: string;

  inputName: string = '';
  canOtherPut: Boolean = true;

  get filter() {
    let dataUsers: DataUser[];
    let dataRegions: DataRegion[];
    dataUsers = this.userState!.dataUser ? this.userState!.dataUser : [];
    dataRegions = this.regionState!.dataRegion
      ? this.regionState!.dataRegion
      : [];

    let filteredArray = dataRegions!.filter((region) => {
      let found = false;
      /*if (dataUsers)
        dataUsers!.forEach((dataUser) => {
          if (dataUser.regions)
            dataUser.regions!.forEach((d) => {
              found = found || region._id === d._id;
            });
        });*/
      return !found;
    });
    return filteredArray.sort(function(a: any, b: any): any {
      if (a.name && b.name) return a.name.localeCompare(b.name);
    });
  }

  private mounted() {
    this.get();
    this.getRegion();
  }

  public input(e: any) {
    this.inputName = e.target.value;
  }

  public putEvent() {
    this.canOtherPut = false;
  }

  public onCancel() {
    this.canOtherPut = true;
    this.get();
    this.getRegion();
  }

  public activeCreate() {
    if (this.canOtherPut === true) {
      this.canOtherPut = false;
      this.userCreate();
    }
  }
  public validateEmail(email: string) {
    var re = /\S+@\S+\.\S+/;
    return re.test(String(email).toLowerCase());
  }

  public onCreate(user: User) {
    let array: User[] = [];
    let email: string = '';
    let username: string = '';
    let type: boolean = false;
    for (let i = 0; i < user.regions!.length; i++) {
      array.push(user.regions![i]);
    }
    email = user.email! !== '' ? user.email! : '';
    username = user.username! !== '' ? user.username! : '';
    type = user.type! === true ? true : false;

    let singleUser = {
      email: email,
      username: username,
      type: type,
      regions: array,
    };
    if (singleUser && singleUser.email !== '' && singleUser.username !== '') {
      if (this.validateEmail(singleUser.email)) {
        this.add(singleUser)
          .then(() => {
            this.canOtherPut = true;
            this.get();
            this.getRegion();
          })
          .catch(() => {});
      } else {
        this.alert({
          prefix: 'INPUT_',
          error: 'NOT_EMAIL',
        });
      }
    } else {
      this.alert({
        prefix: 'INPUT_',
        error: 'EMPTY',
      });
    }
  }

  public onPut(arg: DataUser) {
    let email: string = '';
    let username: string = '';
    let type: boolean = false;
    email = arg.email! !== '' ? arg.email! : '';
    username = arg.username! !== '' ? arg.username! : '';
    type = arg.type! === true ? true : false;

    let singleUser = {
      _id: arg._id,
      email: email,
      username: username,
      type: type,
      regions: arg.regions,
    };
    this.put(singleUser)
      .then(() => {
        this.canOtherPut = true;
        this.get();
        this.getRegion();
      })
      .catch(() => {});
  }

  public onDelete(arg: DataUser) {
    let Conf = confirm('Voulez-vous supprimer cet utilisateur ?');
    if (Conf === true) {
      this.delete(arg._id)
        .then(() => {
          this.get();
          this.getRegion();
        })
        .catch(() => {});
    }
  }

  public addBox(arg: DataUser) {
    this.userPut(arg);
  }

  public deleteBox(arg: DataRegion) {
    this.userDelete(arg);
  }
}
